import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';

/**
 * Wraps a block and fades it up the first time it enters the viewport.
 * Honours prefers-reduced-motion.
 */
const Reveal = ({ children, delay = 0, y = 14, as = 'div', ...rest }) => {
  const reduced = useReducedMotion();
  const Component = motion[as] ?? motion.div;
  return (
    <Component
      initial={reduced ? false : { opacity: 0, y }}
      whileInView={reduced ? undefined : { opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.2 }}
      transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1], delay }}
      {...rest}
    >
      {children}
    </Component>
  );
};

export default Reveal;
